import { useContext, useEffect, useRef } from "react";
import { Context } from "../WhereToBuy/ResultView";
import useTrait from "./syncUpdateState";

const RycoAutoComplete = ({ selectedLatLng }) => {
  const isAU = process.env.NEXT_PUBLIC_SITE_IS_AU == "true";
  const location = useTrait();
  const selectedLocation = useContext(Context);

  const autoCompleteRef = useRef();
  const inputRef = useRef();

  useEffect(() => {
    const options = {
      componentRestrictions: { country: isAU ? "au" : "nz" },
      fields: ["address_components", "geometry", "icon", "name"],
      types: [
        "locality",
        "postal_code",
        "sublocality",
        "administrative_area_level_1",
        "administrative_area_level_2",
      ],
    };

    autoCompleteRef.current = new window.google.maps.places.Autocomplete(
      inputRef.current,
      options
    );

    autoCompleteRef.current.addListener("place_changed", async function () {
      const place = await autoCompleteRef.current.getPlace();
      location.set({
        lat: place?.geometry?.location.lat(),
        lng: place?.geometry?.location.lng(),
        postcode:
          place?.address_components != undefined
            ? place?.address_components[6]?.short_name
            : "",
        state:
          place?.address_components != undefined
            ? place?.address_components[4]?.short_name
            : "",
        country:
          place?.address_components != undefined
            ? place?.address_components[5]?.short_name
            : "",
      });
      selectedLocation.updateMap({
        state: location.get().state,
        postcode: location.get().postcode,
        storeList: [],
        lat: location.get().lat,
        lon: location.get().lng,
        distance: 10000,
      });
    });
  }, [location, isAU]);

  return (
    <div className='input-group'>
      <input
        style={{ boxShadow: "none" }}
        type='text'
        id='postCode'
        ref={inputRef}
        className='form-control'
        name='postCode'
        placeholder='Please enter post code or location'
      />
      <span className='input-group-btn'>
        <input
          style={{ boxShadow: "none" }}
          type='button'
          className='btn btn-danger'
          name='Search'
          defaultValue='Search'
          onChange={() => {
            selectedLocation.updateMap({
              state: location.get().state,
              postcode: location.get().postcode,
              storeList: [],
              lat: location.get().lat,
              lon: location.get().lng,
              distance: 10000,
            });
          }}
        />
      </span>
    </div>
  );
};
export default RycoAutoComplete;
